// import './blocks/banner-slider/render.js';
// import GLightbox from 'glightbox';
// import './assets/css/bootstrap-grid.min.css';
import './assets/css/global-style.sass';


document.addEventListener("DOMContentLoaded", (event) => {
    class imageTab extends HTMLElement {
        constructor() {
            super();
            this.imageWillbe = this.querySelector('.gutenplayer-image-tab-left-img');
            this.singleItems = this.querySelectorAll('.wp-block-templateburg-feature-single');
            this.imgRender();
            this.init();
        }
        imgRender() {
            this.singleItems.forEach((item, index) => {
                // Retrieve the image URL from the `data-img` attribute
                const imageUrl = item.querySelector('.gutenplayer-image-tab-single-content').getAttribute('data-img');
                console.log(imageUrl);

                if (imageUrl) {
                    const divElement = document.createElement('div');
                    divElement.className = "dynamic-image-container"; // Optional: Add a class for styling

                    // Create a new <img> element
                    const imgElement = document.createElement('img');
                    imgElement.src = imageUrl;
                    imgElement.alt = "Dynamic Image";

                    divElement.style.zIndex = this.singleItems.length - index


                    divElement.appendChild(imgElement);
                    // Append the new <img> element to the target container
                    this.imageWillbe.appendChild(divElement);
                }
            });
        }
        init() {
            const imgList = this.querySelectorAll('.dynamic-image-container');

            this.singleItems.forEach((item, index) => {
                item.addEventListener('click', e => {

                    imgList.forEach(singleItem => {
                        singleItem.classList.add('opacity-active')
                        singleItem.classList.remove('active')
                    })
                    item.classList.toggle('active')
                    imgList[index].classList.add('active')
                })
            });

        }
    }
    customElements.define("image-tab", imageTab);

    class colapsImages extends HTMLElement {
        constructor() {
            super();
            this.panel = this.querySelector('.colaps-images-title')
            this.init();
        }
        init() {
            this.panel.addEventListener('click', e => {
                this.classList.toggle('active')
            })
        }
    }
    customElements.define("colaps-images", colapsImages);

    class colapsContent extends HTMLElement {
        constructor() {
            super();
            this.panel = this.querySelector('.colaps-content-title')
            this.init();
        }
        init() {
            this.panel.addEventListener('click', e => {
                this.classList.toggle('active')
            })
        }
    }
    customElements.define("colaps-content", colapsContent);


    class theTabHub extends HTMLElement {
        constructor() {
            super();
            this.tabBtn = this.querySelectorAll('.is-style-text-subtitle');
            this.tabBtnContent = this.querySelectorAll('.tab-content');
            this.init();
        }
        init() {
            this.tabBtn.forEach((item, index) => {
                item.addEventListener('click', e => {
                    this.tabBtn.forEach((innerItem, index) => {
                        innerItem.classList.remove('active')
                        this.tabBtnContent[index].classList.remove('active')
                    })
                    if (!item.classList.contains('active')) {
                        item.classList.add('active')
                        this.tabBtnContent[index].classList.add('active')
                    }
                })
            })
        }
    }
    customElements.define("the-tab", theTabHub);

    class imageHub extends HTMLElement {
        constructor() {
            super();
            this.imageWillbe = this.querySelector('.big-img img');
            this.imageTitleBe = this.querySelector('.big-img .is-style-text-subtitle em');
            this.singleItems = this.querySelectorAll('.small-images');
            this.init();
        }
        init() {

            this.singleItems.forEach((item, index) => {
                const itemImg = item.querySelector('img')
                const itemTitle = item.querySelector('h2')
                const twoImages = item.querySelector('.low-images img')
                console.log(twoImages);

                item.addEventListener('click', () => {
                    this.imageWillbe.srcset = itemImg.srcset
                    this.imageTitleBe.innerHTML = itemTitle.innerHTML
                    twoImages ? this.imageWillbe.srcset = twoImages.srcset : itemImg.srcset
                })

            })
        }
    }
    customElements.define("image-hub", imageHub)
});
